module.exports = __webpack_public_path__ + "img/home_loyalty.8b28b2a0.png";